<div class="dropdown">
  <button class="btn btn-outline-primary profile-menu-toggle dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
    @if (displayedAvatar) {
      <img class="avatar-btn" [src]="displayedAvatar" (error)="handleAvatarLoadError()" [alt]="i18n.t('profileMenu.profileAlt')">
    } @else {
      <span class="avatar-btn avatar-initials" [attr.aria-label]="i18n.t('profileMenu.profileAlt')">{{ initials }}</span>
    }
    <span>{{ profileButtonLabel }}</span>
  </button>
  <div class="dropdown-menu dropdown-menu-end shadow border-0 p-2">
    <div class="px-3 py-2"><strong>{{user?.firstName}} {{user?.lastName}}</strong><br><small class="text-secondary">{{user?.email}}</small></div>
    <hr class="dropdown-divider">
    <a class="dropdown-item" routerLink="/account"><i class="bi bi-person-gear me-2"></i>{{ i18n.t('profileMenu.account') }}</a>
    <a class="dropdown-item" routerLink="/security"><i class="bi bi-shield-lock me-2"></i>{{ i18n.t('profileMenu.security') }}</a>
    <a class="dropdown-item" routerLink="/settings"><i class="bi bi-sliders me-2"></i>{{ i18n.t('profileMenu.settings') }}</a>
    <a class="dropdown-item" routerLink="/files"><i class="bi bi-folder2-open me-2"></i>{{ i18n.t('profileMenu.myFiles') }}</a>
    <hr class="dropdown-divider"><button class="dropdown-item" (click)="session.logout()"><i class="bi bi-box-arrow-right me-2"></i>{{ i18n.t('profileMenu.logout') }}</button>
  </div>
</div>
